import { useMutation, useQuery } from '@apollo/client';
import React from 'react';
import { useSearchParams } from 'react-router';
import useAppSelector from '../../app/redux/useAppSelector';
import Button from '../../components/Button';
import Buttons from '../../components/Buttons';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';
import AccountContentContainer from '../AccountContentContainer';
import * as styles from './McpAuthorizeView.module.scss';

const LOOKUP_QUERY = gql(/** @complexity 1 */ `
  query alphaMcpLookup($clientId: String!) {
    client: alphaMcpLookup(clientId: $clientId) {
      clientName
      clientUri
      logoUri
    }
  }
`);

const AUTHORIZE_MUTATION = gql(/** @complexity 2 */ `
  mutation alphaMcpAuthorize($clientId: String!,$query: String!) {
    redirectTo: alphaMcpAuthorize(clientId: $clientId, query: $query)
  }
`);

const McpAuthorizeView = () => {
  const { organization, user } = useAppSelector((state) => state.session);
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('client_id');

  const [authorizeMcp] = useMutation(AUTHORIZE_MUTATION);
  const onAuthorize = () => {
    authorizeMcp({
      variables: { clientId: clientId!, query: window.location.search },
    }).then(({ data: response }) => {
      if (response?.redirectTo) {
        window.location.href = response.redirectTo;
      }
    });
  };

  const { data, loading } = useQuery(LOOKUP_QUERY, {
    skip: !clientId,
    variables: { clientId: clientId! },
  });

  if (loading) {
    return 'Loading…';
  }
  if (!clientId) {
    return 'Missing client_id';
  }
  if (!data?.client) {
    return 'Client not found';
  }
  const { clientName, clientUri, logoUri } = data.client;
  return (
    <AccountContentContainer
      title={clientName}
      subtitle="wants access to your Slab account"
    >
      <div className={styles.logoContainer}>
        {logoUri && <img src={logoUri} alt={`${clientName} logo`} />}
        {organization.logo?.thumb && (
          <img
            src={organization.logo.thumb}
            alt={`${organization.name} logo`}
          />
        )}
      </div>
      <div className={styles.description}>
        <Link to={clientUri || ''} newTab>
          {clientName}
        </Link>{' '}
        will be able to search, retrieve posts, and run other readonly tools on
        your behalf.
      </div>
      <Buttons>
        <Button block variant="primary" onClick={onAuthorize}>
          Authorize
        </Button>
        <Button block variant="secondary" to="/">
          Cancel
        </Button>
      </Buttons>
      <div className={styles.loggedIn}>
        Logged in as <span className={styles.email}>{user.email}</span> on{' '}
        <span className={styles.host}>{organization.effectiveHost}</span>
      </div>
    </AccountContentContainer>
  );
};

export default McpAuthorizeView;
